module.exports = " <div class=tag-fieldtype-wrapper> <input type=text v-el:tags :value=data /> </div> ";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-html-loader!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/statamic/resources/js/components/fieldtypes/TagsFieldtype.vue
// module id = 755
// module chunks = 0